import getV10APIs from './v1.0';
import getV11APIs from './v1.1';
import getV12APIs from './v1.2';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);
  const v11APIs = getV11APIs(userInfo);
  const v12APIs = getV12APIs(userInfo);

  const children = [
    mergeVersionsByTitle('머리말 꼬리말 조회', v10APIs),
    mergeVersionsByTitle('상품리스트 조회', v12APIs, v11APIs),
    mergeVersionsByTitle('온라인상품 등록', v12APIs, v11APIs),
    mergeVersionsByTitle('온라인상품 상세 리스트 조회', v11APIs),
    mergeVersionsByTitle('온라인상품 상세 조회', v12APIs, v11APIs),
    mergeVersionsByTitle('온라인상품 수정', v12APIs, v11APIs),
    mergeVersionsByTitle('온라인상품 판매수량 수정', v10APIs),
    mergeVersionsByTitle('온라인상품 연동 수정/해제', v10APIs),
    mergeVersionsByTitle('카테고리 조회', v10APIs),
    mergeVersionsByTitle('템플릿 조회', v10APIs),
    mergeVersionsByTitle('쇼핑몰 상품 상태 변경', v10APIs),
    mergeVersionsByTitle('수집 상품 리스트 조회', v10APIs),
    mergeVersionsByTitle('수집 상품 삭제', v10APIs),
  ].filter(Boolean);

  return { title: '상품', children };
};

export default data;
